module.exports = __webpack_public_path__ + "img/crown.c5a71b94.png";